import { cn } from "@/lib/utils"

interface DiagnosticFooterProps {
  className?: string
  children: React.ReactNode
}

export default function DiagnosticFooter({ className, children }: DiagnosticFooterProps) {
  return (
    <div className={cn("flex min-h-[200px] w-full items-center justify-center", className)}>
      {children}
    </div>
  )
}
